import React from 'react'
import TooltipCC from '../TooltipCC'
import { Button } from '@mui/material'
import { ReactComponent as IconUploadFiles } from 'assets/img/IconUploadFiles.svg';
import { ReactComponent as IconUploadFilesNew } from 'assets/img/IconUploadFilesNew.svg';
import { useTranslation } from 'react-i18next';

const ButtonUploadFile = ({
    handleUploadFile,
    isAttachment
}) => {
    const { t } = useTranslation()
    const Icon = isAttachment ? IconUploadFilesNew : IconUploadFiles

    const handleTriggerUploadFile = () => {
        document.getElementById('attachFiles').click()
    }

    return (
        <TooltipCC title={t('attachFiles.titleAdd')}>
            <Button id='trigger-upload-file' variant='outlined' onClick={handleTriggerUploadFile} startIcon={<Icon style={{ marginRight: 4, minWidth: '24px' }} />}>{t('attachFiles.titleAdd')}</Button>
            <input
                type="file"
                id="attachFiles"
                name="attachFiles"
                style={{ display: 'none', whiteSpace: 'nowrap' }}
                onChange={handleUploadFile}
                multiple
                accept=".zip,.rar,.7zip, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/*, .mp4, .pdf, .doc, .docx, .ptt, .ppt, .pptx, .txt, .mp3, .csv"
            />
        </TooltipCC>
    )
}

export default ButtonUploadFile